module.exports = __webpack_public_path__ + "static/websites3-9951c9d0f8df7c97c1f36d66301fa924.jpg";